import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { observer } from 'mobx-react-lite';
import { Form, Button, Container, Grid, Segment, Image, Divider, Header, List, Icon, Input, Item, Label } from 'semantic-ui-react';
import 'mobx-react-lite/batchingForReactDom';
import history from '../../../browserHistory';
import { getStoredValue } from '../../../shared/utils/localStorage';
import { DEV_API_URL, API_PRODUCT_GET_ENDPOINT, API_PRODUCT_UPDATE_ENDPOINT } from '../../../shared/constants'
import styled, { css } from 'styled-components';
import { FlexCard } from './../../../elements';
import { ButtonWithConfirmation } from '../../../views/engine/AdminLayout/ButtonWithConfirmation';

const ProductDetailsNew = (props) => {
  const [product, setProduct] = useState('');
  const [viewBids, setViewBids] = useState(false);
  const [viewOffers, setViewOffers] = useState(false);
  const [removeFromSale, setRemoveFromSale] = useState(false);

  const sectionBorderColor = removeFromSale ? 'red' : 'green';

  const showNonProductDetailComponents = false;
  const gridColumns = showNonProductDetailComponents ? 12 : 16;

  const loadProduct = (product) => setProduct(product);

  return (
    <>
      <Container fluid>
        <Container fluid>
          <Header as="h1">{product}</Header>
        </Container>
        <Grid stackable padded columns={2}>
          {showNonProductDetailComponents && <Grid.Column width={4}>
            <ProductImages />
          </Grid.Column>}
          <Grid.Column width={gridColumns}>
            
            <Grid stackable>
          {showNonProductDetailComponents && 
              <Grid.Row stretched columns={2}>
                <Grid.Column width={6}>
                  <EventInformation sectionBorderColor={sectionBorderColor} />
                </Grid.Column>
                <Grid.Column width={10}>
                  <BlockInformation 
                    removedFromSale={removeFromSale}
                    removeFromSale={() => setRemoveFromSale((prevState) => !prevState)}
                    viewingBids={viewBids} 
                    viewBids={() => setViewBids((prevState) => !prevState)} 
                    viewingOffers={viewOffers}
                    viewOffers={() => setViewOffers((prevState) => !prevState)} 
                    sectionBorderColor={sectionBorderColor} 
                  />
                </Grid.Column>
              </Grid.Row>}
              {viewBids && (
                <Grid.Row>
                  <Grid.Column width={16}>
                    Bids                  
                  </Grid.Column>
                </Grid.Row>
              )}
              {viewOffers && (
                <Grid.Row>
                  <Grid.Column width={16}>
                    Offers
                  </Grid.Column>
                </Grid.Row>
              )}
              <Grid.Row>
                <Grid.Column width={16}>
                  <ProductInformation 
                    props={props} 
                    loadProduct={loadProduct} 
                    // sectionBorderColor={sectionBorderColor} 
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid>
      </Container>
    </>
  );
};

export default ProductDetailsNew

export const StyledLabel = styled.h4`
  padding: 0px;
  margin: 0px;
`;

export const StyledValue = styled.div``;

export const InlineKeyValuePair = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
  width: 100%;
 
  && ${StyledLabel} {
    padding-left: 5px;
    width: 175px;
    height: 40px;
    display: flex;
    align-items: center;
  }
  && ${StyledValue} {
    padding-right: 5px;
  }
`;

export const StyledFlexCard = styled(FlexCard)`
  && h3 {
    margin-right: 20px !important;
  }  import { filter } from 'lodash';

`;

export const ReadOnlyCard = styled(FlexCard)`
  width: 100%;
  margin: 0px 7px;
  && label {
    font-weight: 700;
    font-size: .92857143em;
    margin-bottom: 5px; 
  }
  && div {
    border: 1px solid rgba(34,36,38,.15);
    border-radius: .28571429rem;
    line-height: 1.21428571em;
    padding: .67857143em 1em;
    font-size: 1em;
    width: 100%;
    ${({ type }) => css`
      min-height: 35px;
      ${ type === 'dropdown' && 'min-height: 38px;' }
      ${ type === 'textarea' && 'min-height: 75px;' }
    `}
  }
`;

export const ShadedSegment = styled(Segment)`
  && {
    background-color: #f7f7f7;
  }
`;

export const formatCommas = (value) => new Intl.NumberFormat().format(value);
export const formatCurrency = (symbol, value) => `${symbol} ${formatCommas(value)}`

export const SegmentLabel = ({ content }) => {
  return <Label attached='top left' style={{ backgroundColor: '#e7e7e7' }}>{content}</Label>
}

export const FormElement = ({ label, width, name, id, formattedValue, value, onChange, disabled, editMode, type, placeholder, selection, clearable, options, icon }) => {
  const isInputWithLeftAttachedLabel = (type === 'text' || type === 'number') && icon;
  const isDefaultInput = (type === 'text' || type === 'number') && !icon;
  const isTextArea = type === 'textarea';
  const isDropDown = type === 'dropdown';

  return editMode ? (
    <>
      {isTextArea && (
        <Form.TextArea
          id={id}
          label={label}
          name={name}
          onChange={onChange}
          placeholder={placeholder}
          value={value}
        />
      )}
      {isDropDown && (
        <Form.Dropdown
          clearable={clearable}
          id={id}
          label={label}
          name={name}
          options={options}
          placeholder={placeholder}
          selection={selection}
        />
      )}
      {isInputWithLeftAttachedLabel && (
        <Form.Field>
          <label>{label}</label>
          <Input
            disabled={disabled}
            id={id}
            label={icon?.name}
            labelPosition={icon?.position}
            name={name}
            onChange={onChange}
            type={type}
            value={value}
            width={width}
          />
        </Form.Field>
      )}
      {isDefaultInput && (
        <Form.Input
          disabled={disabled}
          id={id}
          label={label}
          name={name}
          onChange={onChange}
          type={type}
          value={value}
          width={width}
        />
      )}
    </>
  ) : (
    <ReadOnlyCard type={type} direction="column">
      <label>{label}</label>
      <div>{formattedValue ?? value}</div>
    </ReadOnlyCard>
  );
}

export const ImageGroup = ({ size, images, editMode }) => {
 return ( 
   <FlexCard direction="row" horizontalAlignment="space-between">
    {images.map((image, index) => <ImageContainer key={index} image={image} size={size} sequence={index + 1} editMode={editMode} />)}
  </FlexCard>
 )
};

export const ImageContainer = ({ image, size, sequence, editMode }) => {
  const primaryImageIndicator = sequence === 1 ? { as: 'a', corner: 'left', icon: 'star', color: 'blue' } : null; 
  return (
    <StyledImageContainer direction="row" horizontalAlignment="space-evenly">
      <Image src={image} size={size} fluid label={primaryImageIndicator} />
      {editMode && (
        <div>
          <FormElement  placeholder="Sequence" type="number" label="Sequence" name="Sequence" id="sequence" value={sequence} onChange={(e) => null} editMode={editMode} />
          <Button size="mini" icon="refresh" content="Reload" primary onClick={() => null} />
        </div>
      )}
    </StyledImageContainer>
  );
}

export const StyledImageContainer = styled.div` 
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  & img {
    width: 50%;
  }
  & div {
    padding: 0 5px;
    input {
      max-width: 60px !important;
      height: 30px;

    }
    & > div > label {
      width: 100%;
    }
    & > div > div {
      margin-bottom: 5px;
    }
    & > div {
      display: block;
      width: 60px;
    }
  }
`;





export const ProductImages = () => {
  const [editMode, setEditMode] = useState(false);
  const images = [
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
    "https://npasimulcast.blob.core.windows.net/simulcastblob/pictures/source/6497bda6-a864-eb11-80cf-005056afaeea/b3fd4742-2a97-eb11-80d6-005056afaeea/c8fd4742-2a97-eb11-80d6-005056afaeea.jpg",
  ];

  const [primaryImage, ...nonPrimaryImages] = images;

  return (
    <>
      <Segment>
        <Image
          fluid
          label={{ as: 'a', corner: 'left', icon: 'star', color: 'blue' }}
          src={primaryImage}
        />
      </Segment>
      <Container padded>
        {editMode ? (
         <Button as="div" labelPosition="right">
         <Button size="tiny" color="blue" basic onClick={(e) => {
           e.preventDefault();
           setEditMode((prevState) => !prevState);
         }}>
           <Icon name="cancel" />
           Cancel Image Edit
         </Button>
         <Label as="a" basic color="blue" pointing="left">
           {images.length}
         </Label>
       </Button>
       ) : (
       <Button as="div" labelPosition="right">
          <Button size="tiny" color="blue" onClick={(e) => {
            e.preventDefault();
            setEditMode((prevState) => !prevState);
          }}>
            <Icon name="edit" />
            Edit Images
          </Button>
          <Label as="a" basic color="blue" pointing="left">
            {images.length}
          </Label>
        </Button>
       )}
        {editMode && <Button size="tiny" color="blue" floated="right">
          <Icon name="refresh" />
          Reload All Images
        </Button>}
      </Container>
      <Divider />
      <Container>
      <Form onSubmit={() => null}>
        <ImageGroup size="small" images={images} editMode={editMode} />
      </Form>
      </Container>    
    </>
  )
}

export const EventInformation = ({ sectionBorderColor }) => (
  <ShadedSegment color={sectionBorderColor}>
    <List divided verticalAlign="middle">
      <List.Item>
        <List.Content>
          <Header as="h3">Event Information</Header>
        </List.Content>
      </List.Item>
    </List>
    <Segment>
      <InlineKeyValuePair>
        <StyledLabel>Auction Name:</StyledLabel>
        <StyledValue>San Diego Auction 4/2/2021</StyledValue>
      </InlineKeyValuePair>
      <InlineKeyValuePair>
        <StyledLabel>Lane Name:</StyledLabel>
        <StyledValue>Off Road/RV/Other Lane</StyledValue>
      </InlineKeyValuePair>
      <InlineKeyValuePair>
        <StyledLabel>Seller Name:</StyledLabel>
        <StyledValue>John Doe (123456789)</StyledValue>
      </InlineKeyValuePair>
      <InlineKeyValuePair>
        <StyledLabel>Pre-Bidding Start Time:</StyledLabel>
        <StyledValue>April 1, 2021 4:00 PM (PST)</StyledValue>
      </InlineKeyValuePair>
      <InlineKeyValuePair>
        <StyledLabel>Auction Start Time:</StyledLabel>
        <StyledValue>April 2, 2021 8:00 AM (PST)</StyledValue>
      </InlineKeyValuePair>
      <InlineKeyValuePair>
        <StyledLabel>Time Left:</StyledLabel>
        <StyledValue>2 Hours, 53 minutes</StyledValue>
      </InlineKeyValuePair>
    </Segment>
  </ShadedSegment>
);

export const BlockInformation = ({ removedFromSale, removeFromSale, viewingBids, viewBids, viewingOffers, viewOffers, sectionBorderColor }) => (
  <ShadedSegment color={sectionBorderColor}>
    <List divided verticalAlign='middle'>
      <List.Item>
        <List.Content><Header as="h3">On Block Information</Header></List.Content>
      </List.Item>
    </List>
    <Segment>
      <Container>
        <Grid stackable>
          <Grid.Row columns={2}>
            <Grid.Column>
              <InlineKeyValuePair>
                <StyledLabel>Status:</StyledLabel>
                <StyledValue style={{ color: 'green' }}>In Progress</StyledValue>
              </InlineKeyValuePair>
              <InlineKeyValuePair>
                <StyledLabel>Starting Bid:</StyledLabel>
                <StyledValue>$10,000</StyledValue>
              </InlineKeyValuePair>
              <InlineKeyValuePair>
                <StyledLabel>High Bid:</StyledLabel>
                <StyledValue>$11,200</StyledValue>
              </InlineKeyValuePair>
              <InlineKeyValuePair>
                <StyledLabel>Bid Increment:</StyledLabel>
                <StyledValue>$200</StyledValue>
              </InlineKeyValuePair>
              {/* <InlineKeyValuePair>
                <StyledLabel>Quantity:</StyledLabel>
                <StyledValue>1 Vehicle</StyledValue>
              </InlineKeyValuePair> */}
            </Grid.Column>
            <Grid.Column>
              <InlineKeyValuePair>
                <StyledLabel>Reserve Amount:</StyledLabel>
                <StyledValue>$12,500</StyledValue>
              </InlineKeyValuePair>
              <InlineKeyValuePair>
                <StyledLabel>Reserve Type:</StyledLabel>
                <StyledValue>FIRM</StyledValue>
              </InlineKeyValuePair>
              <InlineKeyValuePair>
                <StyledLabel>Start Time:</StyledLabel>
                <StyledValue>
                <Label as='a' basic color='green'>
                    9:42:02
                  </Label>
                </StyledValue>
              </InlineKeyValuePair>
              <InlineKeyValuePair>
                <StyledLabel>End Time:</StyledLabel>
                <StyledValue>
                <Label basic color='red' pointing='right'>
                    47 seconds
                  </Label>
                  <Label as='a' title='47 seconds' basic color='red'>
                    9:42:49
                  </Label>
                  </StyledValue>
              </InlineKeyValuePair>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row columns={1}>
            <Grid.Column>
              <Container textAlign="center">
                {removedFromSale ? (
                  <Button content="Add to Sale" icon="add circle" primary onClick={(e) => {
                    e.preventDefault();
                    removeFromSale();
                  }} />  
                ) : (
                  // <ButtonWithConfirmation
                  //   buttonText="Remove from Sale"
                  //   buttonIcon="remove circle"
                  //   onConfirmation={(e) => {
                  //     e.preventDefault();
                  //     removeFromSale();
                  //   }}
                  //   disabled={false}
                  //   loading={false}
                  // />
                  <Button content="Remove from Sale" icon="remove circle" negative onClick={(e) => {
                    e.preventDefault();
                    removeFromSale();
                  }} />
                )}
                <Button as='div' labelPosition='right'>
                  <Button color='green' onClick={(e) => {
                    e.preventDefault();
                    viewBids();
                  }}>
                    <Icon name='gavel' />
                    {viewingBids ? 'Hide' : 'View'} Bids
                  </Button>
                  <Label as='a' basic color='green' pointing='left'>
                    6
                  </Label>
                </Button>
                <Button as='div' labelPosition='right'>
                  <Button color='black' onClick={(e) => {
                    e.preventDefault();
                    viewOffers();
                  }}>
                    <Icon name='dollar' />
                    {viewingOffers ? 'Hide' : 'View'} Offers
                  </Button>
                  <Label as='a' basic color='black' pointing='left'>
                    2
                  </Label>
                </Button>
              </Container>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  </ShadedSegment>    
);

export const ProductInformation = observer(({props, loadProduct, sectionBorderColor }) => {

  const [product, setProduct] = useState('')
  const [sequence, setSequence] = useState('')
  const [lotNumber, setLotNumber] = useState('')
  const [bookValue, setBookValue] = useState('')
  const [startPrice, setStartPrice] = useState('')
  const [reserve, setReserve] = useState('')
  const [target, setTarget] = useState('')
  const [publicComments, setPublicComments] = useState('')
  const [privateComments, setPrivateComments] = useState('')
  const [minStartPrice, setMinStartPrice] = useState('')
  const [sellerMin, setSellerMin] = useState('')
  const [buyerMax, setBuyerMax] = useState('')
  const [bidderNumber, setBidderNumber] = useState('')
  const [bidderName, setBidderName] = useState('')
  const [bidIncrement, setBidIncrement] = useState('')
  const [stockNumber, setStockNumber] = useState('')
  const [highBidAmount, setHighBidAmount] = useState('')
  const [subjectToMinOffer, setSubjectToMinOffer] = useState('')
  const [sellTime, setSellTime] = useState('')
  const [onBlockStartTime, setOnBlockStartTime] = useState('')
  const [onBlockEndTime, setOnBlockEndTime] = useState('')
  // const [productEditMode, setProductEditMode] = useState('false')
  const [productEditMode, setProductEditMode] = useState(false)
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const updateProduct = async () => {
      const sessionToken = getStoredValue('simulcastadmin_session');
      const updateProductUrl = DEV_API_URL + API_PRODUCT_UPDATE_ENDPOINT;
      const params = JSON.stringify({
        sessionToken: sessionToken,
        productID: props.ProductID,
        productEntity: {
          product: product,
          sequence: sequence,
          lotNumber: lotNumber,
          bookValue: bookValue,
          startPrice: startPrice,
          reserve: reserve,
          target: target,

          publicComments: publicComments,
          privateComments: privateComments,
          minStartPrice: minStartPrice,
          sellerMin: sellerMin,
          buyerMax: buyerMax,
          bidderNumber: bidderNumber,
          bidderName: bidderName,

          stockNumber: stockNumber,
          highBidAmount: highBidAmount,
          subjectToMinOffer: subjectToMinOffer,
          sellTime: null,
          onBlockEndTime: null,
          onBlockStartTime: null,
          bidIncrement,
        }
      })
      // console.log('updateProduct', params);
      const productDetailsResponse = await axios.post(updateProductUrl, params, {
        "headers": {
          "content-type": "application/json"
        }
      });

      if (productDetailsResponse.status === 200) {
        history.goBack();
      }
    }
    updateProduct();
  }


  useEffect(() => {
    const productDetails = async () => {
      const productDetailsUrl = DEV_API_URL + API_PRODUCT_GET_ENDPOINT;
      const sessionToken = getStoredValue('simulcastadmin_session');
      const params = JSON.stringify({
        sessionToken: sessionToken,
        productID: props.ProductID
      })
      const productDetailsResponse = await axios.post(productDetailsUrl, params, {
        "headers": {
          "content-type": "application/json"
        }
      });

      const productDetails = productDetailsResponse.data.product;


      setProduct(productDetails.product);
      setSequence(productDetails.sequence);
      setLotNumber(productDetails.lotNumber);
      setBookValue(productDetails.bookValue);
      setStartPrice(productDetails.startPrice);
      setReserve(productDetails.reserve);
      setTarget(productDetails.target);
      setPublicComments(productDetails.publicComments);
      setPrivateComments(productDetails.privateComments);
      setMinStartPrice(productDetails.minStartPrice);
      setSellerMin(productDetails.sellerMin);
      setBuyerMax(productDetails.buyerMax);
      setBidderNumber(productDetails.bidderNumber);
      setBidderName(productDetails.bidderName);
      setBidIncrement(productDetails.bidIncrement);
      setStockNumber(productDetails.stockNumber);
      setHighBidAmount(productDetails.highBidAmount);
      setSubjectToMinOffer(productDetails.subjectToMinOffer);
      setSellTime(productDetails.sellTime);
      if (productDetails.onBlockStartTime instanceof Date && isNaN(productDetails.onBlockStartTime)) {
        setOnBlockStartTime(productDetails.onBlockStartTime);
      }
      if (productDetails.onBlockEndTime instanceof Date && isNaN(productDetails.onBlockEndTime)) {
        setOnBlockEndTime(productDetails.onBlockEndTime);
      }

      loadProduct(productDetails.product);
    }
    productDetails();

  }, []);


  const dollarIconLabel = { name: '$', position: 'left' };

  const showDataThatDoesNothing = false;
  return (
    <Form onSubmit={handleSubmit}>
      <ShadedSegment color={sectionBorderColor}>
        <List divided verticalAlign='middle'>
          <List.Item>
            <List.Content floated='right'>
              {!productEditMode && (
                <Button content="Edit" icon="edit" size="mini" primary 
                  onClick={(e) => {
                    e.preventDefault();
                    setProductEditMode((prevState) => !prevState)}
                  } 
                />
              )}
              {showDataThatDoesNothing && <Label color='grey'>
                <Icon name='clock' />Last Modified
                <Label.Detail>March 28, 2021 2:43:56 PM (PST)</Label.Detail>
              </Label>}
            </List.Content>
            <List.Content>
              <StyledFlexCard>
                <Header as="h3">Product Information</Header>
                
              </StyledFlexCard>
            </List.Content>
          </List.Item>
        </List>
        <Segment>
          <Container fluid>
            <Grid stackable columns={3}>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <ShadedSegment padded>
                    <SegmentLabel content="Identifiers" />
                    <Form.Group>
                      <FormElement placeholder="Product Title" type="text" label="Product Title" width={16} id="product" value={product} onChange={(e) => { setProduct(e.target.value) }} disabled={!productEditMode} editMode={productEditMode} />
                    </Form.Group>
                    <Form.Group widths={3}>
                      <FormElement placeholder="Sequence" type="number" label="Sequence" name="Sequence" id="sequence" value={sequence} onChange={(e) => { setSequence(e.target.value) }} editMode={productEditMode} />
                      <FormElement placeholder="Lot Number" type="text" label="Lot Number" name="lotNumber" id="lotNumber" value={lotNumber} onChange={(e) => { setLotNumber(e.target.value) }} editMode={productEditMode} />
                      <FormElement placeholder="Stock Number" type="text" label="Stock Number" name="stockNumber" id="stockNumber" value={stockNumber} onChange={(e) => { setStockNumber(e.target.value) }} editMode={productEditMode} />
                    </Form.Group>
                  </ShadedSegment>
                </Grid.Column>
                <Grid.Column width={8}>
                  <ShadedSegment padded>
                    <SegmentLabel content="Bid Details" />
                    <Form.Group widths={2}>
                      <FormElement placeholder="Default Bid Increment" label="Default Bid Increment" name="bidIncrement" id="bidIncrement" type="text" formattedValue={formatCurrency('$', bidIncrement)} value={bidIncrement} onChange={(e) => { setBidIncrement(e.target.value) }} editMode={productEditMode} icon={dollarIconLabel} />
                      <FormElement placeholder="Buyer Max" label="Buyer Max" name="buyerMax" id="buyerMax" type="text" formattedValue={formatCurrency('$', buyerMax)} value={buyerMax} onChange={(e) => { setBuyerMax(e.target.value) }} editMode={productEditMode} icon={dollarIconLabel} />
                    </Form.Group>
                    <Form.Group widths={2}>
                      <FormElement placeholder="Min Start Price" label="Min Start Price" name="minStartPrice" id="minStartPrice" type="text" formattedValue={formatCurrency('$', minStartPrice)} value={minStartPrice} onChange={(e) => { setMinStartPrice(e.target.value) }} editMode={productEditMode} icon={dollarIconLabel} />
                      <FormElement placeholder="Start Price" label="Start Price" name="startPrice" id="startPrice" type="text" formattedValue={formatCurrency('$', startPrice)} value={startPrice} onChange={(e) => { setStartPrice(e.target.value) }} editMode={productEditMode} icon={dollarIconLabel}/>
                    </Form.Group>
                  </ShadedSegment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <ShadedSegment padded>
                    <SegmentLabel content="Attributes" />
                    <Form.Group widths={2}>
                      <FormElement placeholder="Reserve" label="Reserve" name="reserve" id="reserve" type="text" formattedValue={formatCurrency('$', reserve)} value={reserve} onChange={(e) => { setReserve(e.target.value) }} editMode={productEditMode}  icon={dollarIconLabel} />
                      {showDataThatDoesNothing && <FormElement placeholder="Reserve Type" label="Reserve Type" name="reserveType" id="reserveType" type="dropdown" clearable options={[{ key: 1, text: 'Firm', value: 1 }, { key: 2, text: 'Close', value: 2 }, { key: 3, text: 'Average', value: 3 }]} selection editMode={productEditMode} />}
                      <FormElement placeholder="Target" label="Target" name="target" id="target" type="text" formattedValue={formatCurrency('$', target)} value={target} onChange={(e) => { setTarget(e.target.value) }} editMode={productEditMode} icon={dollarIconLabel}/>
                      <FormElement placeholder='Book Value' label="Book Value" name="bookValue" id="bookValue" type="text" formattedValue={formatCurrency('$', bookValue)} value={bookValue} onChange={(e, { value }) => { setBookValue(value) }} editMode={productEditMode} icon={dollarIconLabel} />
                    </Form.Group>
                  </ShadedSegment>
                </Grid.Column>
                <Grid.Column>
                  <ShadedSegment padded>
                    <SegmentLabel content="Seller Details" />
                    <Form.Group widths={2}>
                      <FormElement placeholder="Seller Min" label="Seller Min" name="sellerMin" id="sellerMin" type="text" formattedValue={formatCurrency('$', sellerMin)} value={sellerMin} onChange={(e) => { setSellerMin(e.target.value) }} editMode={productEditMode} icon={dollarIconLabel} />
                      <FormElement placeholder="Subject/To Min Offer" label="Subject/To Min Offer" name="subjectToMinOffer" id="subjectToMinOffer" type="text" formattedValue={formatCurrency('$', subjectToMinOffer)} value={subjectToMinOffer} onChange={(e) => { setSubjectToMinOffer(e.target.value) }} editMode={productEditMode} icon={dollarIconLabel} />
                      <FormElement placeholder="Sell Time" label="Sell Time" name="sellTime" id="sellTime" type="text" value={sellTime} onChange={(e) => { setSellTime(e.target.value) }} editMode={productEditMode}></FormElement>
                    </Form.Group>
                  </ShadedSegment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column>
                  <ShadedSegment padded>
                    <SegmentLabel content="Comments" />
                    <Form.Group widths={2}>
                      <FormElement type="textarea" label="Public Comments" name="publicComments" id="publicComments" placeholder='Public Comments' value={publicComments} onChange={(e) => { setPublicComments(e.target.value) }} editMode={productEditMode}></FormElement>
                      <FormElement type="textarea" label="Private Comments" name="privateComments" id="privateComments" placeholder='Private Comments' value={privateComments} onChange={(e) => { setPrivateComments(e.target.value) }} editMode={productEditMode}></FormElement>
                    </Form.Group>
                  </ShadedSegment>
                </Grid.Column>
              </Grid.Row><Grid.Row columns={1}>
                <Grid.Column>
                  <ShadedSegment padded>
                    <SegmentLabel content="Other" />
                    <Form.Group widths={2}>
                      <Form.Input label="On Block Start Time" name="onBlockStartTime" id="onBlockStartTime" type="text" value={onBlockStartTime} onChange={(e) => { setOnBlockStartTime(e.target.value) }}></Form.Input>
                      <Form.Input label="On Block End Time" name="onBlockEndTime" id="onBlockEndTime" type="text" value={onBlockEndTime} onChange={(e) => { setOnBlockEndTime(e.target.value) }}></Form.Input>
                    </Form.Group>
                  </ShadedSegment>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
        {/* <Segment>
          <Form.Group>
            <Form.Input label="Product Title" width={8} id="product" type="text" value={product} onChange={(e) => { setProduct(e.target.value) }} disabled={productEditMode == 'false'} />
          </Form.Group>
          <Form.Group widths={5}>
            <Form.Input name="Sequence" label="Sequence" id="sequence" type="text" value={sequence} onChange={(e) => { setSequence(e.target.value) }} />
            <Form.Input label="Lot Number" name="lotNumber" id="lotNumber" type="text" value={lotNumber} onChange={(e) => { setLotNumber(e.target.value) }} />
            <Form.Input label="Book Value" name="bookValue" id="bookValue" type="text" value={bookValue} onChange={(e, { value }) => { setBookValue(value) }}></Form.Input>
            <Form.Input label="Start Price" name="startPrice" id="startPrice" type="text" value={startPrice} onChange={(e) => { setStartPrice(e.target.value) }}></Form.Input>
            <Form.Input label="Reserve" name="reserve" id="reserve" type="text" value={reserve} onChange={(e) => { setReserve(e.target.value) }}></Form.Input>
          </Form.Group>
          <Form.Group widths={5}>
            <Form.Input label="Target" name="target" id="target" type="text" value={target} onChange={(e) => { setTarget(e.target.value) }}></Form.Input>
            <Form.Input label="Min Start Price" name="minStartPrice" id="minStartPrice" type="text" value={minStartPrice} onChange={(e) => { setMinStartPrice(e.target.value) }}></Form.Input>
            <Form.Input label="Seller Min" name="sellerMin" id="sellerMin" type="text" value={sellerMin} onChange={(e) => { setSellerMin(e.target.value) }}></Form.Input>
            <Form.Input label="High Bid Amount" name="highBidAmount" id="highBidAmount" type="text" value={highBidAmount} onChange={(e) => { setHighBidAmount(e.target.value) }}></Form.Input>
            <Form.Input label="Buyer Max" name="buyerMax" id="buyerMax" type="text" value={buyerMax} onChange={(e) => { setBuyerMax(e.target.value) }}></Form.Input>
          </Form.Group>
          <Form.Group widths={5}>
            <Form.Input label="Bidder Number" name="bidderNumber" id="bidderNumber" type="text" value={bidderNumber} onChange={(e, { value }) => { setBidderNumber(value) }}></Form.Input>
            <Form.Input label="Bidder Increment" name="bidIncrement" id="bidIncrement" type="text" value={bidIncrement} onChange={(e) => { setBidIncrement(e.target.value) }}></Form.Input>
            <Form.Input label="Stock Number" name="stockNumber" id="stockNumber" type="text" value={stockNumber} onChange={(e) => { setStockNumber(e.target.value) }}></Form.Input>
            <Form.Input label="Subject To Min Offer" name="subjectToMinOffer" id="subjectToMinOffer" type="text" value={subjectToMinOffer} onChange={(e) => { setSubjectToMinOffer(e.target.value) }}></Form.Input>
            <Form.Input label="Sell Time" name="sellTime" id="sellTime" type="text" value={sellTime} onChange={(e) => { setSellTime(e.target.value) }}></Form.Input>
          </Form.Group>
          <Form.Group widths={5}>
            <Form.Input label="On Block Start Time" name="onBlockStartTime" id="onBlockStartTime" type="text" value={onBlockStartTime} onChange={(e) => { setOnBlockStartTime(e.target.value) }}></Form.Input>
            <Form.Input label="On Block End Time" name="onBlockEndTime" id="onBlockEndTime" type="text" value={onBlockEndTime} onChange={(e) => { setOnBlockEndTime(e.target.value) }}></Form.Input>
          </Form.Group>                
          <Form.Group widths={2}>
            <Form.TextArea label="Public Comments" name="publicComments" id="publicComments" type="text" value={publicComments} onChange={(e) => { setPublicComments(e.target.value) }}></Form.TextArea>
            <Form.TextArea label="Private Comments" name="privateComments" id="privateComments" type="text" value={privateComments} onChange={(e) => { setPrivateComments(e.target.value) }}></Form.TextArea>
          </Form.Group>

          <Button type="submit" primary width="1">Update Product</Button>
        </Segment> */}
        {productEditMode && (
          <Container fluid textAlign='right'>
            <Button type="cancel" content="Cancel" icon="cancel" basic 
              onClick={(e) => {
                e.preventDefault();
                setProductEditMode((prevState) => !prevState)}
              }  
            />
            <Button type="submit" content="Save Product" icon="save" primary />
          </Container>
        )}
      </ShadedSegment>
      
    </Form>    
  )
});
